import type { ReactNode } from 'react';

/** The inspector's shared label, value and spacing rhythm. */
export function PropertyField({ label, children, className = '' }: { label: string; children: ReactNode; className?: string }) {
  return <div className={`inspector-field ${className}`}><span className="inspector-field-label">{label}</span>{children}</div>;
}
